import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";

export const usePenilaianKaryawan = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [listOperator, setListOperator] = useState();

  const [operatorPick, setOperatorPick] = useState();

  const [data, setData] = useState({});
  const [dataRekapitulasi, setDataRekapitulasi] = useState();
  const [subMenu, setSubMenu] = useState("Habis Kontrak");
  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  const [listPenilaian, setListPenilaian] = useState([]);
  const [rekomendasi, setRekomendasi] = useState("Rekomendasi");

  const [category, setCategory] = useState("Kategori");

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/formLembur`,
      { tim: dataUser.tim, type: "getUser" },
      dataUser.auth,
      setListOperator,
      ""
    );
  }, []);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getRekapitulasi`,
      {
        tim: dataUser.tim,
        id: operatorPick?.value,
        bulan: data?.bulanKontrak,
      },
      dataUser.auth,
      setDataRekapitulasi,
      ""
    );
  }, [data?.bulanKontrak, operatorPick]);

  useEffect(() => {
    if (subMenu === "Habis Kontrak") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getPenilaianKaryawan`,
        {
          tim: dataUser.tim,
          filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
          requestor: dataUser.id,
          category: "Habis",
        },
        dataUser.auth,
        setListPenilaian,
        ""
      );
    }
    if (subMenu === "Tahunan") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getPenilaianKaryawan`,
        {
          tim: dataUser.tim,
          filterDate: `${filterTahun}`,
          requestor: dataUser.id,
          category: "Tahunan",
        },
        dataUser.auth,
        setListPenilaian,
        ""
      );
    }
  }, [subMenu, filterBulan, filterTahun]);

  let reFormat = [];
  listOperator &&
    listOperator.forEach((element) => {
      reFormat.push({ value: element.id, label: element.name });
    });

  const handleKirimPenilaianKaryawan = () => {
    if (
      operatorPick &&
      data.bulanKontrak &&
      data.rajin &&
      data.taat &&
      data.hasil &&
      data.sikap &&
      data.pelanggaran &&
      ((rekomendasi !== "Rekomendasi" && category !== "Kategori") ||
        category === "Tahunan")
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/inputPenilaian`,
        {
          tim: dataUser.tim,
          id: operatorPick,
          data: data,
          dataRekapitulasi: dataRekapitulasi,
          category: category,
          creator: dataUser.name,
          rekomendasi: rekomendasi === "yes" ? true : false,
        },
        dataUser.auth,
        "",
        ""
      );

      setTimeout(() => {
        setOperatorPick();
        setRekomendasi("Rekomendasi");
        setData({});
        setDataRekapitulasi();
        setCategory("Kategori");
      }, 300);
    }
  };

  return {
    dataUser,
    reFormat,
    operatorPick,
    setOperatorPick,
    data,
    setData,
    dataRekapitulasi,
    handleKirimPenilaianKaryawan,
    subMenu,
    setSubMenu,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    listPenilaian,
    rekomendasi,
    setRekomendasi,
    category,
    setCategory,
  };
};
